export function constantZero() {
  return 0;
}

export default function(x) {
  return function() {
    return x;
  };
}



//////////////////
// WEBPACK FOOTER
// ./~/d3/~/d3-hierarchy/src/constant.js
// module id = 138
// module chunks = 0 1 2 3 4